import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

import logo from "../../assets/images/logo.png";
import "./styles.css";

export function ImprimirDefeitoColaborador({ visible, setIsVisible, data }) {
    const [colaboradores, setColaboradores] = useState([]);

    const component = useRef();

    const handlePrint = useReactToPrint({
        content: () => component.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
        }
    });

    function onHide() {
        setIsVisible(false);
    }

    useEffect(() => {
        if (data) {
            let colaboradores = [];

            data.forEach((item) => {
                if (colaboradores.indexOf(item.colaborador) === -1) {
                    colaboradores.push(item.colaborador);
                }
            });

            let array = [];
            colaboradores.forEach((colaborador) => {
                let filtered = data.filter((element) => {
                    return colaborador === element.colaborador;
                });

                let total = filtered.reduce((acc, curr) => {
                    let valorMetragem = typeof curr.metragem === 'string' 
                        ? parseFloat(curr.metragem.replace(',', '.')) 
                        : parseFloat(curr.metragem);
                    
                    return acc + (isNaN(valorMetragem) ? 0 : valorMetragem);
                }, 0);

                array.push({
                    "colaborador": colaborador,
                    "items": filtered,
                    "totalMetragem": total
                });
            });

            setColaboradores(array);
        }
    }, [data, visible]);

    return (
        <Dialog onHide={onHide} visible={visible}>
            <Button className="p-m-1" icon="pi pi-print" onClick={handlePrint} />
            <div ref={component}>
                {colaboradores &&
                    colaboradores.map((item, index) => {
                        
                        const footerGroup = (
                            <ColumnGroup>
                                <Row>
                                    <Column footer={`${item.colaborador ? item.colaborador : ''} - Total:`} colSpan={5} footerStyle={{ textAlign: 'right', fontWeight: 'bold' }} />
                                    <Column footer={item.totalMetragem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} footerStyle={{ fontWeight: 'bold' }}/>
                                    <Column />
                                </Row>
                            </ColumnGroup>
                        );

                        return (
                            <div className="page" id="page" key={index}>
                                <img src={logo} alt="Logo da Cambos em PNG" />
                                <h2>DEFEITOS CONTÍNUOS NA REVISÃO</h2>
                                <DataTable style={{ fontSize: 15, width: "80%" }} size="small" value={item.items}footerColumnGroup={footerGroup}>
                                    <Column header="Tear" field="tear" />
                                    <Column header="Artigo" field="artigo" />
                                    <Column header="Turma" field="turma" />
                                    <Column header="Data Corte" field="data_corte_formatada" />
                                    <Column header="Defeito" field="defeito" />
                                    <Column header="(m)" field="metragem" />
                                    <Column header="Tecelão" field="colaborador" />
                                </DataTable>
                                <div className="box-assinatura">
                                    <div className="col">
                                        <div className="assinatura"></div>
                                        <h2>ASS. CONTRAMESTRE</h2>
                                    </div>
                                    <div className="col">
                                        <div className="assinatura"></div>
                                        <h2>ASS. COLABORADOR</h2>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </Dialog>
    );
}
